'use strict'

var reduce = require('./reduce')

module.exports = function concat (cb) {
  return reduce(function (a, b) {
    return a + b
  }, '', cb)
}



//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sinks/concat.js
// module id = 772
// module chunks = 0